export default () => {
  const input_containers = document.querySelectorAll("li.binary-choice__option");
  input_containers.forEach((input_container) => {
    input_container.addEventListener("click", function () {
      this.querySelector("input[type=radio]").click();
    });
  });
};
